<div class="table-data-estimate estimate-service-item flex-start-start p-0 pb-2 pt-2" id="SC{{ serviceId }}{{ index }}"
  [ngClass]="{ 'sub-flat-rate-item': isFlatRateSubItem, 'bg-light-gray': serviceItem?.lineItemType === 'refund',
  'parts-lookup-wrapper': type === 'partLookUp' }">
  <!-- Parts look-up mpl loader -->
  <div class="mpl-loader-wrapper" [ngClass]="{'active': isDialogOpening}">
    <div class="mpl-loader-content">
      <div class="mpl-img">
        <img src="../../../../../assets/img/mpl-purple-loader.gif" alt="">
      </div>
      <div class="mpl-content">Searching for applicable {{serviceItem?.title}}...</div>
    </div>
  </div>
  <!-- Start Service Type Dropdown -->
  <div class="item type position-relative" [ngClass]="{ 'pl-4': isFlatRateSubItem }">
    <i *ngIf="serviceItem?.type == 'bundle'" class="expand-icon p-1 pointer fal"
      [ngClass]="{ 'fa-chevron-down': serviceItem?.isExpanded, 'fa-chevron-up': !serviceItem?.isExpanded }"
      (click)="toggleExpand()"></i>

    <div tooltipPosition="top" tooltipStyleClass="overlflow-zindex"
      pTooltip="{{ serviceItem?.itemId ? 'Remove ' + selectedType.label + ' to change type' : '' }}"
      [ngClass]="{ 'not-allowed': serviceItem?.itemId && serviceItem?.type != 'bundle' }">
      <div [ngClass]="{ 'disabled-with-default': isArchived, 'flat-rate-item-bundle': serviceItem?.type == 'bundle' }">
        <app-auto-complete id="estimate-service-item-type-{{ cardIndex }}-{{ index }}"
          listId="estimate-service-item-type-list-{{ cardIndex }}-{{ index }}" name="est-item-type" field="label"
          highlightField="highlightField" styleClassInput="pl-2 not-allowed" styleClassInputWrapper=""
          inactiveItemsKey="value" theme="{{ focus?.type ? 'primary' : 'light' }}" styleClassListWrapper="top-38"
          styleClassError="top-35 left-10" itemWidth="165px" scrollHeight="240px" placeholder="Select*"
          [textTruncate]="true"
          [disabled]="serviceItem?.lineItemType === 'refund' || serviceItem.isArchived || serviceItem?.itemId"
          [isSetPositionDynamically]="true" [selectTextOnFocus]="true" [delay]="10" [minSearchLength]="1"
          [value]="selectedType.label" [leftIcon]="serviceItem?.type === 'partLookUp' ? 'lookup-image-item' : ''"
          [suggestions]="itemTypeOptions" [isDropdownIconVisible]="true" [selectionOnTab]="true"
          [highlightFirstSelectedValue]="true" (click)="estTypeScroll()"
          (appSelect)="handleDropdownSelect('type', $event)" (appFocus)="handleFocus('type')"
          (appEnter)="handleBlur('type')" (appBlur)="handleBlur('type')" (appTabPress)="handleBlur('type')"
          (appCompletedMethod)="handleTypeSearch($event)" (appBlur)="handleBlur('type')"
          (appClear)="handleClear('type')">
          <ng-template appTemplate="item" let-item let-query="query">
            <div [ngClass]="{ 'item-disabled not-allowed': serviceItem?.itemId }" *ngIf="item?.label && !query">
              {{ item?.title }}
              <img [src]="partsOrderingIcons[item?.partsOrderingType]" />
            </div>
            <div [ngClass]="{ 'item-disabled not-allowed': serviceItem?.itemId }" *ngIf="query"
              [innerHTML]="highlighedItemType(item.title, query, item.partsOrderingType)"></div>
          </ng-template>
        </app-auto-complete>
      </div>
    </div>
  </div>
  <!-- End Service Type Dropdown -->

  <!-- Start Service Description -->
  <div class="item description" [ngClass]="{ 'quickbook-comp': isQuickbooksCalCompatibiltyOn }">
    <div
      [ngClass]="{'w-100 word-break-breakall': type === 'sublet', 'sublet-description-overflow' : (!focus.description && type === 'sublet' && serviceItem.title)}">
      <div *ngIf="type === 'other' || (type === 'sublet' && (focus.description || !serviceItem.title))">
        <!-- <app-input id="estimate-service-item-name-{{ cardIndex }}-{{ index }}" name="est-item-title"
      theme="{{ focus?.description ? 'primary' : 'light' }}"
      placeholder="{{ type === 'labor' ? 'Enter name*' : 'Enter name' }}" styleClassInput="pl-0" styleClass="pl-0"
      styleClassError="top-35 left-10" [disabled]="serviceItem?.lineItemType === 'refund' || isArchived"
      [selectTextOnFocus]="true" [value]="serviceItem.title" [isInvalid]="!serviceItem.title && errors?.title"
      [fontSize]="12" [autoFocus]="focus.title" (appFocus)="handleFocus('description')"
      (appBlur)="handleBlur('description')" (appChange)="handleChange('title', $event)">
    </app-input> -->

        <!-- Replacing Other's input field with textarea to fix ALP-14607 -->
        <app-textarea textAreaId="estimate-service-item-name-{{ cardIndex }}-{{ index }}" name="est-item-title"
          [theme]="focus?.description ? 'primary' : 'light'"
          placeholder="{{ type === 'labor' ? 'Enter name*' : 'Enter name' }}" styleClassInput="pl-0" styleClass="pl-0"
          styleClassError="top-35 left-10" [rows]="2" [autoGrow]="true" [maxLength]="500" [maxAutoGrowHeight]="96"
          [disabled]="serviceItem?.lineItemType === 'refund' || isArchived" [selectTextOnFocus]="true"
          [value]="companyLocalization && currentLang === 'fr' ? (serviceItem.titleFR || serviceItem.title) : (serviceItem.title || serviceItem.titleFR)"
          [isInvalid]="!serviceItem.title && errors?.title" [fontSize]="12" [autoFocus]="focus.title"
          (appFocus)="handleFocus('description')" (appBlur)="handleBlur('description')"
          (appChange)="handleChange('title', $event)">
        </app-textarea>
      </div>
      <div *ngIf="!focus.description && type === 'sublet' && serviceItem.title" class="pt-1 flex-between-start">
        <span class="font-12" [ngClass]="{'not-allowed': isArchived || isUpdating}"
          (click)="serviceItem?.lineItemType !== 'refund' ? openSubletSupplierDialog() : ''">{{serviceItem.title}}</span>
        <div class="p-1 z-index-10 flex-start-start" (click)="handleFocus('description'); focus.title = true"
          *ngIf="!isSubletDescriptionUpdating && serviceItem?.lineItemType !== 'refund'">
          <i class="fal fa-edit font-12" tooltipPosition="top" pTooltip="Edit sublet name"></i>
        </div>
        <div class="p-1 z-index-10 flex-start-start" *ngIf="isSubletDescriptionUpdating">
          <i class="fal fa-spinner rotate font-12"></i>
        </div>
      </div>

      <div
        *ngIf="['part', 'tire', 'labor', 'tireStorage', 'hazmatFee', 'discount', 'bundle', 'partLookUp'].includes(type) || !serviceItem.type"
        class="position-relative estimate-canned-types"
        [ngClass]="{ 'service-underline': serviceItem?.itemId, 'parts-lookup': serviceItem?.type === 'partLookUp'}">
        <div>
          <!-- hidden input -->
          <input *ngIf="serviceItem?.itemId || (serviceItem?.type === 'partLookUp' && !serviceItem?._id)" type="text"
            class="hidden-input" (focus)="handleFocus('cross')" (blur)="handleBlur('cross')"
            (keydown.enter)="handleRemoveItem()" />

          <app-auto-complete name="est-item-title" styleClassInputWrapper="pl-0" styleClassListWrapper="top-38"
            placeholder="{{getPlaceHolder(type)}}" styleClassError="top-35 left-10" field="title"
            listId="ac-estimate-service-item-name-list-{{ cardIndex }}-{{ index }}" inactiveItemsKey="status"
            noRecordText="No items match your search" styleClassInput="pl-0" [selectTextOnFocus]="true"
            [isLoading]="isSearching" [selectionOnTab]="true" [highlightFirstSelectedValue]="true"
            [allowMultiline]="serviceItem?.itemId" [maxAutoGrowHeight]="96"
            [textAreaId]="serviceItem?._id + serviceItem?.itemId + serviceId + index" [showDisabledIcon]="false"
            [selectInactiveItems]="false" [openDropdownOnGetResult]="true"
            [itemWidth]="serviceItem?.type === 'tireStorage' && isTireStorage2Enabled ? '190px' : itemResults?.length ? '600px' : ''"
            [theme]="(serviceItem?.invalid || !focus?.partLookUp) && !isFlatRateSubItem ? 'primary' : 'light'"
            [disabled]="serviceItem?.lineItemType === 'refund' || serviceItem?.itemId || isArchived || (serviceItem?.type === 'partLookUp' && serviceItem._id)"
            [autoFocus]="focus.titleSearch" [fontSize]="12"
            [hasCustomListTemplate]="hasDividedResults && !isSearching && ['labor', 'tireStorage'].includes(serviceItem.type) && itemResults?.length"
            [isDropdownIconVisible]="!serviceItem?.itemId && (serviceItem?.type === 'partLookUp' && !serviceItem?._id)"
            [errorMessage]="errors?.title" [closeOnSelection]="true"
            [scrollHeight]="hasDividedResults ? '505px' : '288px'" [value]="getServiceItemTitle() || ''"
            [hasCustomEditableField]="['part', 'tire', 'hazmatFee', 'discount', 'bundle'].includes(type) || (['labor', 'tireStorage'].includes(type) && (!hasDividedResults || !itemResults?.length) && !isTireStorage2Enabled) || (['labor'].includes(type) && (!hasDividedResults || !itemResults?.length))"
            [suggestions]="itemResults" [isInvalid]="serviceItem.invalid" (appFocus)="showSuggestions(type)"
            (appChange)="handleTitleChange($event)"
            (appSelect)="serviceItem?.type === 'tireStorage' && isTireStorage2Enabled ? '' : handleSelect(type, $event,null,false,serviceItem,cardIndex,index)"
            (appClickOutside)="handleBlur(type)" (appCompletedMethod)="searchSuggestion($event, type)"
            (appClickInput)="!isArchivedRO ? handleOpenItemModal(serviceItem?.itemId, false) : ''"
            (appClear)="handleClearService(serviceItem)">

            <ng-template let-item appTemplate="item" let-query="query">
              <div *ngIf="item?.type !== 'discount' && item.type === 'partLookUp'">
                <div>{{item?.name}}</div>
              </div>

              <div *ngIf="item?.type !== 'discount' && item.type !== 'partLookUp'"
                class="service-item-details search-item flex-between-center" [ngClass]="{ disabled: !item?.status }">
                <div class="flex-start-center s-item-content-sec">
                  <div class="flex-center-center mr-2">
                    <i *ngIf="['part', 'tire', 'labor', 'tireStorage', 'hazmatFee', 'partLookUp'].includes(item?.type)"
                      class="{{ searchTypeIcon[item?.type] }} font-gray-75"></i>
                  </div>

                  <div class="item-title-section flex-column flex-center-start text-truncate pr-2">
                    <span class="flex-start-center font-secondary-700 text-truncate width-100p">
                      <!-- <span *ngIf="item?.code && item?.type === 'part'">{{item?.code}}&nbsp;-&nbsp;</span> -->
                      <div class="text-truncate" tooltipPosition="top" *ngIf="!companyLocalization"
                        [pTooltip]="item?.type === 'part' ? item?.itemTitle : item?.title"
                        [ngClass]="{ 'item-disabled not-allowed': serviceItem?.itemId }"
                        [innerHTML]="highlighedItemType(item?.type === 'part' ? item?.itemTitle : item?.title, query)">
                      </div>
                      <div class="text-truncate" tooltipPosition="top" *ngIf="companyLocalization"
                        [pTooltip]="item?.type === 'part'
                        ? ((item.searchBy === 'titleFR' ? item?.itemTitleFR : item?.itemTitle) || item?.itemTitleFR || item?.itemTitle)
                        : ((item.searchBy === 'titleFR' ? item?.titleFR : item?.title) || item?.titleFR || item?.title)"
                        [ngClass]="{ 'item-disabled not-allowed': serviceItem?.itemId }" [innerHTML]="highlighedItemType(
                          item?.type === 'part'
                          ? ((item.searchBy === 'titleFR' ? item?.itemTitleFR : item?.itemTitle) || item?.itemTitleFR || item?.itemTitle)
                          : ((item.searchBy === 'titleFR' ? item?.titleFR : item?.title) || item?.titleFR || item?.title),
                          query)">
                      </div>
                    </span>
                    <span class="font-11 font-gray-55 tire-description text-truncate" tooltipPosition="top"
                      *ngIf="companyLocalization" tooltipStyleClass="list-tooltip limit-tooltip-text"
                      [pTooltip]="item?.notes">
                      {{ (serviceItem?.type !== 'bundle' ? ( item.searchBy === 'titleFR' ? item?.descriptionFR :
                      item?.notes) :
                      ( item.searchBy === 'titleFR' ? item?.descriptionFR : item?.description)) ||
                      'No description' }}
                    </span>
                    <span class="font-11 font-gray-55 tire-description text-truncate" tooltipPosition="top"
                      *ngIf="!companyLocalization" tooltipStyleClass="list-tooltip limit-tooltip-text"
                      [pTooltip]="item?.notes">
                      {{ serviceItem?.type !== 'bundle' ? item?.notes : item?.description ||
                      'No description' }}
                    </span>
                    <span class="font-11 font-gray-55 tire-description text-truncate"
                      *ngIf="(item?.type === 'part' || item?.type === 'tire') && item.stocked">
                      {{isMultiLocationEnabled && isStockTransferEnabled ? 'Qty on hand (local)' : 'Qty on hand'
                      }}:&nbsp;{{ isMultiLocationEnabled ?
                      item?.stockDetails?.countInHand : item?.countInHand|| 0 }}
                    </span>

                    <span class="font-11 font-gray-55 tire-description text-truncate"
                      *ngIf="(item?.type === 'part' || item?.type === 'tire') && isMultiLocationEnabled && isStockTransferEnabled && isStockTransferEnabled && item.stocked">
                      Qty on hand (other): {{ item?.stockDetails?.qtyOnHandOther || 0 }}
                    </span>
                  </div>
                </div>

                <div class="flex-end-center"
                  [ngClass]="isMultiLocationEnabled ? 's-item-price-sec-mul' : 's-item-price-sec'">
                  <div class="flex-column width-100p">
                    <div *ngIf="serviceItem?.type !== 'bundle'; else bundleTopRight"
                      class="font-secondary-700 flex-between-center">
                      <span class="font-600">Price</span>
                      <span class="font-600">&nbsp;{{ item.feeValueType === 'percent' ? item.price +
                        '%' : (item.price || 0 | currency : usd) }}</span>
                    </div>

                    <ng-template #bundleTopRight>
                      <div class="font-secondary-700 flex-end-center">
                        Price&nbsp;&nbsp;{{ item.feeValueType === 'percent' ?
                        item.flatRate + '%' : (item.flatRate || 0 | currency :
                        usd) }}
                      </div>
                    </ng-template>

                    <div *ngIf="serviceItem?.type !== 'bundle'; else bundleBottomRight"
                      class="font-11 font-gray-55 flex-between-center">
                      <span>Cost</span>
                      <span>&nbsp;{{ item.feeValueType === 'percent' ? item.cost +
                        '%' : (item.cost || 0 | currency : usd) }}
                      </span>
                    </div>

                    <ng-template #bundleBottomRight>
                      <div class="font-secondary-700 flex-end-center">
                        Items:&nbsp;&nbsp;{{ item?.itemTotal?.totalItemCount ||
                        0 | number : '1.2-2' }}
                      </div>
                    </ng-template>

                    <div class="font-11 font-gray-55" [ngClass]="!isMultiLocationEnabled ? 'content-end' : ''"
                      *ngIf="(item?.type === 'part' || item?.type === 'tire') && item.stocked">
                      <span>{{isMultiLocationEnabled && isStockTransferEnabled ?
                        'Qty available (local)': 'Qty available' }}:&nbsp;{{ isMultiLocationEnabled ?
                        item?.stockDetails?.countAvailable : item?.countAvailable || 0 }}
                      </span>
                    </div>
                    <div class="font-11 font-gray-55"
                      *ngIf="(item?.type === 'part' || item?.type === 'tire') && isMultiLocationEnabled && isStockTransferEnabled && item.stocked">
                      <span>Qty available (other): {{ item?.stockDetails?.qtyAvailableOther || 0
                        }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="item?.type === 'discount'" class="service-item-details search-item flex-between-center"
                [ngClass]="{ disabled: !item?.status }">
                <div class="flex-start-center s-item-content-sec">
                  <div class="flex-center-center mr-2">
                    <i class="{{ searchTypeIcon[item?.type] }} font-gray-75"></i>
                  </div>

                  <div class="item-title-section flex-column flex-center-start text-truncate pr-2">
                    <span class="flex-start-center font-secondary-700 text-truncate width-100p">
                      <!-- without localization flag -->
                      <div class="text-truncate" tooltipPosition="top" [pTooltip]="item?.title"
                        *ngIf="!companyLocalization" [ngClass]="{ 'item-disabled not-allowed': serviceItem?.itemId }"
                        [innerHTML]="highlighedItemType(item?.title, query)"></div>
                      <!-- with localization flag -->
                      <div class="text-truncate" tooltipPosition="top" [pTooltip]="item?.title"
                        *ngIf="companyLocalization && item.searchBy === 'title'"
                        [ngClass]="{ 'item-disabled not-allowed': serviceItem?.itemId }"
                        [innerHTML]="highlighedItemType(item?.title || item?.titleFR, query)"></div>
                      <div class="text-truncate" tooltipPosition="top" [pTooltip]="item?.titleFR"
                        *ngIf="companyLocalization && item.searchBy === 'titleFR'"
                        [ngClass]="{ 'item-disabled not-allowed': serviceItem?.itemId }"
                        [innerHTML]="highlighedItemType(item?.titleFR || item?.title, query)"></div>
                    </span>


                    <!-- without localization flag -->
                    <span class="font-11 font-gray-55 tire-description text-truncate" tooltipPosition="top"
                      *ngIf="!companyLocalization" tooltipStyleClass="list-tooltip limit-tooltip-text"
                      [pTooltip]="item?.description">
                      {{ item?.description || 'No description' }}
                    </span>
                    <!-- with localization flag -->
                    <span class="font-11 font-gray-55 tire-description text-truncate" tooltipPosition="top"
                      *ngIf="companyLocalization && item.searchBy === 'title'"
                      tooltipStyleClass="list-tooltip limit-tooltip-text" [pTooltip]="item?.description">
                      {{ item?.description || 'No description' }}
                    </span>
                    <span class="font-11 font-gray-55 tire-description text-truncate" tooltipPosition="top"
                      *ngIf="companyLocalization && item.searchBy === 'titleFR'"
                      tooltipStyleClass="list-tooltip limit-tooltip-text" [pTooltip]="item?.description">
                      {{ item?.descriptionFR || 'No description' }}
                    </span>
                  </div>
                </div>

                <div class="flex-end-center s-item-price-sec">
                  <div class="flex-column width-100p">
                    <div class="font-11 font-secondary-700 content-end">
                      <span class="price-info">Value:</span>
                      <span *ngIf="item?.discountType === 'percentage'" class="bold-label">
                        {{ item?.discountValue }}%
                      </span>

                      <span *ngIf="item?.discountType !== 'percentage'" class="bold-label">
                        {{ item?.discountValue | currency : usd }}
                      </span>
                    </div>

                    <div class="font-11 font-gray-55 content-end"
                      [ngClass]="{ invisible: item?.discountType !== 'percentage' }">
                      <span class="mr-1">Max:</span>
                      <span>{{ item?.discountCap | currency : usd }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template let-query="query" let-selectedIndex="selectedIndex" let-close="close" appTemplate="list">
              <li *ngIf="!isTireStorage2Enabled || serviceItem?.type === 'labor'" class="font-13 font-600 font-gray-45 p-2 labor-suggestion-label">
                <span *ngIf="serviceItem?.type === 'labor'">AUTOLEAP RESULTS</span>
                <span *ngIf="serviceItem?.type === 'tireStorage' && !isTireStorage2Enabled">Currently in storage (Select
                  tires to return)</span>
              </li>

              <li *ngIf="!isTireStorage2Enabled || serviceItem?.type === 'labor'" class="labor-suggestions-local">
                <ul class="labor-suggestions-local-list" id="e-serviceItem-local-labor">
                  <li *ngFor="let item of primarySuggestions; let i = index" data-extra-scroll-offset="40"
                    data-container="e-serviceItem-local-labor" data-parent="e-serviceItem-local-labor"
                    data-scroll-height="252" data-extra-scroll-offset="37" class="p-2" id="item-{{ i }}"
                    [ngClass]="{ highlighted: i == selectedIndex }" (click)="handleSelect(type, item, close)">
                    <div class="service-item-details search-item flex-between-center"
                      [ngClass]="{ disabled: !item?.status }">
                      <div class="flex-start-center s-item-content-sec">
                        <div class="flex-center-center mr-2">
                          <i class="far fa-{{ icons[serviceItem?.type] }} font-gray-75"></i>
                        </div>

                        <div class="item-title-section flex-column flex-center-start text-truncate pr-2">
                          <span class="flex-start-center font-secondary-700 text-truncate width-100p font-12">
                            <span *ngIf="item?.code && item?.code !== '0'">{{ item?.code }}&nbsp;-&nbsp;</span>
                            <div class="text-truncate font-12" [pTooltip]="item?.title" *ngIf="!companyLocalization"
                              tooltipPosition="top" [innerHTML]="highlighedItemType(item?.title, query)"></div>

                            <div class="text-truncate font-12" [pTooltip]="item?.title || item?.titleFR"
                              tooltipPosition="top" *ngIf="companyLocalization && item.searchBy === 'title'"
                              [innerHTML]="highlighedItemType(item?.title || item?.titleFR, query)"></div>

                            <div class="text-truncate font-12" [pTooltip]="item?.titleFR || item?.title"
                              tooltipPosition="top" *ngIf="companyLocalization && item.searchBy === 'titleFR'"
                              [innerHTML]="highlighedItemType(item?.titleFR || item?.title, query)"></div>
                            <span *ngIf="item?.type ==='tireStorage' && item?.externalId">&nbsp; . &nbsp;TS# {{
                              item?.externalId }}</span>
                          </span>
                          <span class="font-11 font-gray-55 tire-description text-truncate" [pTooltip]="item.notes"
                            *ngIf="!companyLocalization" tooltipPosition="top"
                            tooltipStyleClass="list-tooltip limit-tooltip-text">
                            {{ item?.notes || 'No description' }}
                          </span>
                          <span class="font-11 font-gray-55 tire-description text-truncate" [pTooltip]="item.notes"
                            *ngIf="companyLocalization && item.searchBy === 'title'" tooltipPosition="top"
                            tooltipStyleClass="list-tooltip limit-tooltip-text">
                            {{ item?.notes || item?.description || 'No description' }}
                          </span>
                          <span class="font-11 font-gray-55 tire-description text-truncate"
                            [pTooltip]="item?.descriptionFR" *ngIf="companyLocalization && item.searchBy === 'titleFR'"
                            tooltipPosition="top" tooltipStyleClass="list-tooltip limit-tooltip-text">
                            {{ item?.descriptionFR || 'No description' }}
                          </span>
                          <span class="font-11 font-gray-55 tire-description text-truncate"
                            *ngIf="(item?.type === 'part' || item?.type === 'tire') && item.stocked">
                            Qty on hand: {{ item?.countInHand || 0 }}
                          </span>
                        </div>
                      </div>

                      <div class="flex-end-center s-item-price-sec">
                        <div class="flex-column width-100p">
                          <div class="font-11 font-secondary-700 content-end">
                            <span class="price-info">Price:</span>
                            <span class="bold-label">{{ item?.price | currency : usd }}</span>
                          </div>
                          <div class="font-11 font-gray-55 content-end">
                            <span class="mr-1">Cost:</span>
                            <span>{{ item?.cost | currency : usd }}</span>
                          </div>
                          <div class="font-11 font-gray-55 content-end"
                            *ngIf="(item?.type === 'part' || item?.type === 'tire') && item.stocked">
                            <span>Qty available: {{ item?.countAvailable || 0
                              }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li class="p-2 flex-start-center font-primary labor-create"
                    [hidden]="serviceItem?.type === 'tireStorage' && isTireStorage2Enabled"
                    (click)="handleOpenItemModal(null, true)">
                    <i class="fal fa-user-hard-hat pr-2 font-12"></i>
                    <span class="font-12">Add new
                      <span class="text-lowercase">{{ labels[serviceItem?.type] }}</span></span>
                  </li>
                </ul>
              </li>

              <li *ngIf="!isTireStorage2Enabled || serviceItem?.type === 'labor'" class="font-13 font-600 font-gray-45 p-2 labor-suggestion-label">
                <div class="flex-between-center">
                  <span *ngIf="serviceItem?.type === 'labor' && secondarySuggestions?.length">MOTOR RESULTS</span>
                  <span *ngIf="serviceItem?.type === 'tireStorage' && !isTireStorage2Enabled">Add to storage</span>
                  <span *ngIf="serviceItem?.type === 'labor'" class="motor-logo">
                    <img src="../../../../../assets/img/motor.png" alt="" />
                  </span>
                </div>
              </li>

              <!-- Motor Labor Items -->
              <li *ngIf="serviceItem?.type === 'labor'" class="labor-suggestions-motor labor-suggestions-local"
                id="e-serviceItem-motor-labor">
                <div *ngFor="let motorItem of secondarySuggestions">
                  <ul *ngFor="let mItem of motorItem.items">
                    <li class="p-2" data-extra-scroll-offset="290" data-container="e-serviceItem-local-labor"
                      data-parent="e-serviceItem-motor-labor" id="item-{{ mItem.index }}"
                      data-sibling="e-serviceItem-local-labor" data-scroll-height="504"
                      [ngClass]="{ highlighted: mItem.index == selectedIndex }"
                      (click)="handleSelect(type, mItem, close)">
                      <div class="service-item-details search-item flex-between-center"
                        [ngClass]="{ disabled: !mItem?.status }">
                        <div class="flex-start-center s-item-content-sec">
                          <div class="flex-center-center mr-2">
                            <i
                              class="far {{ serviceItem?.type === 'labor' ? icons.labor : icons.tire }} font-gray-75"></i>
                          </div>

                          <div class="item-title-section flex-column flex-center-start text-truncate pr-2">
                            <span class="flex-start-center font-secondary-700 text-truncate width-100p font-12">
                              <div class="text-truncate font-12" [innerHTML]="highlighedItemType(mItem?.title, query)"
                                [pTooltip]="mItem?.title" tooltipPosition="top"></div>
                            </span>
                            <span class="font-11 font-gray-55 text-truncate tire-description"
                              [pTooltip]="mItem?.description" tooltipPosition="top">
                              {{ mItem?.description || 'No description' }}
                            </span>
                          </div>
                        </div>

                        <div class="flex-end-center s-item-price-sec">
                          <div class="flex-column width-100p">
                            <div class="font-11 font-secondary-700 flex-end-center">
                              <span>{{ mItem?.count || 0 }} hrs</span>
                            </div>
                            <div class="font-11 font-gray-55 flex-end-center">
                              <span>{{ mItem?.laborType || '' }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <!-- Tire storage items -->
              <li *ngIf="serviceItem?.type === 'tireStorage'"
                class="tirestorage-suggestions-motor tirestorage-suggestions-local" id="e-serviceItem-motor-labor">
                <ng-container *ngIf="isTireStorage2Enabled">

              <li class="p-2 flex-start-center tire-storage-header" *ngIf="isTireInTemplates()?.length">
                <div class="service-item-details search-item flex-between-center">
                  <span class="flex-start-center text-truncate font-bold font-12" style="width: 160px;">
                    Tires In
                  </span>
                </div>
              </li>

              <ul *ngFor="let template of tireStorageTemplates">
                <li *ngIf="!template.isTireOut" class="p-2 flex-start-center" tooltipPosition="top"
                  tooltipStyleClass="tire-storage-tt"
                  [pTooltip]="template.isTireOut && !showTiresOutItemLine() ? 'No tires currently in storage. Store tires to use this option.' : ''"
                  [ngClass]="{'disabled-storage-line':template.isTireOut && !showTiresOutItemLine()}"
                  (click)="template.isTireOut && !showTiresOutItemLine() ? '' : openTiresInOutModal(template.isTireOut, template, close)">
                  <div class="service-item-details search-item flex-between-center">
                    <div class="flex-start-center s-item-content-sec">
                      <div class="item-title-section flex-column flex-center-start text-truncate pr-2">
                        <span class="flex-start-center font-secondary-700 text-truncate font-12" style="width: 160px;">
                          <!-- [pTooltip]="template.isTireOut ? template.title : 'Tires In - ' + template.title" -->
                          <span class="text-truncate">{{ template.isTireOut ? template.title : 'Tires In - ' +
                            template.title}}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>

              <li class="p-2 flex-start-center tire-storage-header">
                <div class="service-item-details search-item flex-between-center">
                  <span class="flex-start-center text-truncate font-bold font-12" style="width: 160px;">
                    Tires Out
                  </span>
                </div>
              </li>

              <ul *ngFor="let template of tireStorageTemplates">
                <li *ngIf="template.isTireOut" class="p-2 flex-start-center" tooltipPosition="top"
                  tooltipStyleClass="tire-storage-tt"
                  [pTooltip]="template.isTireOut && !showTiresOutItemLine() ? 'No tires currently in storage. Store tires to use this option.' : ''"
                  [ngClass]="{'disabled-storage-line':template.isTireOut && !showTiresOutItemLine()}"
                  (click)="template.isTireOut && !showTiresOutItemLine() ? '' : openTiresInOutModal(template.isTireOut, template, close)">
                  <div class="service-item-details search-item flex-between-center">
                    <div class="flex-start-center s-item-content-sec">
                      <div class="item-title-section flex-column flex-center-start text-truncate pr-2">
                        <span class="flex-start-center font-secondary-700 text-truncate font-12" style="width: 160px;">
                          <span class="text-truncate">{{ template.isTireOut ? template.title : 'Tires In - ' +
                            template.title}}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              </ng-container>
              <ng-container *ngIf="!isTireStorage2Enabled">
                <div *ngFor="let motorItem of secondarySuggestions">
                  <ul *ngFor="let mItem of motorItem.items">
                    <li class="p-2" data-extra-scroll-offset="290" data-container="e-serviceItem-local-labor"
                      data-parent="e-serviceItem-motor-labor" id="item-{{ mItem.index }}"
                      data-sibling="e-serviceItem-local-labor" data-scroll-height="504"
                      [ngClass]="{ highlighted: mItem.index == selectedIndex }"
                      (click)="createTireStorage(mItem, close)">
                      <div class="service-item-details search-item flex-between-center"
                        [ngClass]="{ disabled: !mItem?.status }">
                        <div class="flex-start-center s-item-content-sec">
                          <div class="flex-center-center mr-2">
                            <i class="far fa-{{ icons[serviceItem?.type] }} font-gray-75"></i>
                          </div>

                          <div class="item-title-section flex-column flex-center-start text-truncate pr-2">
                            <span class="flex-start-center font-secondary-700 text-truncate width-100p font-12">
                              <span *ngIf="mItem?.code && mItem?.code !== '0'">{{ mItem?.code }}&nbsp;-&nbsp;</span>
                              <div class="text-truncate font-12" [pTooltip]="mItem?.title" tooltipPosition="top"
                                [innerHTML]="highlighedItemType(mItem?.title, query)"></div>
                            </span>
                            <span class="font-11 font-gray-55 tire-description text-truncate" [pTooltip]="mItem.notes"
                              tooltipPosition="top" tooltipStyleClass="list-tooltip limit-tooltip-text">
                              {{ mItem?.notes || 'No description' }}
                            </span>
                          </div>
                        </div>

                        <div class="flex-end-center s-item-price-sec">
                          <div class="flex-column width-100p">
                            <!-- <div class="font-11 font-secondary-700 flex-between-center">
                              <span>Price</span>
                              <span>{{mItem?.price | currency: usd}}</span>
                            </div>
                            <div class="font-11 font-gray-55 flex-between-center">
                              <span>Cost</span>
                              <span>{{mItem?.cost | currency: usd}}</span>
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </ng-container>
              </li>
            </ng-template>

            <ng-container
              *ngIf="serviceItem?.type === 'tireStorage' && isTireStorage2Enabled; else addnewTeamplate"></ng-container>
            <ng-template #addnewTeamplate let-item appTemplate="editable">
              <p id="estimate-service-item-part-{{ cardIndex }}-{{ index }}" class="m-0 pl-1 font-11"
                (click)="handleOpenItemModal(null, true)">
                + Add new
                <span class="text-lowercase">{{ labels[serviceItem?.type] }}</span>
              </p>
            </ng-template>
          </app-auto-complete>
        </div>

        <div class="remove-item p-1 z-index-10"
          [hidden]="!serviceItem?.itemId || serviceItem?.lineCartId || isFlatRateSubItem || isArchivedRO || isArchived"
          [ngClass]="{'not-allowed': isFinalizedRo || (serviceItem?.type === 'hazmatFee' && serviceItem?.isPassThroughFet)}"
          (click)="handleDeleteItem()">
          <i class="fal fa-times" [ngClass]="{ 'font-primary': focus?.cross }"></i>
        </div>
      </div>
    </div>
  </div>
  <!-- End Service Description -->


  <!-- without partsLookup -->
  <!-- without partsLookup normal behavior -->
  <ng-container *ngIf="type !== 'partLookUp'"> <!-- Start Service Notes Section -->
    <div class="item notes" [ngClass]="{'quickbook-comp': isQuickbooksCalCompatibiltyOn
    }">
      <app-textarea [rightIcon]="isFinalizedRo ? 'fal fa-expand-alt active-icon':'fal fa-expand-alt'"
        placeholder="Enter description text" styleClassInput="pl-0" [styleClassLabel]="!isFinalizedRo && 'cursor-text'"
        styleClass="pl-0" textAreaId="IT{{ serviceId }}{{ index }}" [maxLength]="10000" [selectTextOnFocus]="true" [rows]="1"
        [autoGrow]="true" [maxAutoGrowHeight]="96" [theme]="focus?.notes ? 'primary' : 'light'" [fontSize]="12"
        [value]="helperService.getLocalizationValue(currentLang, serviceItem, 'description')" [autoFocus]="focus.notes"
        [disabled]="serviceItem?.lineItemType === 'refund' || !serviceItem?.type || isArchived || isFinalizedRo || (serviceItem?.type !== 'other' && serviceItem?.type !== 'sublet' && !serviceItem?.itemId) || serviceItem?.type === 'bundle' || (!serviceItem?.title && !serviceItem?.titleFR)"
        (appChange)="handleChange('notes', $event)" (appFocus)="handleFocus('notes')" (appBlur)="handleBlur('notes')"
        (appRightIconClick)="handleOpenNotesTab('notes')">
      </app-textarea>
    </div>
    <!-- End Service Notes Section -->

    <!-- Start Service Cost Section -->
    <div class="item cost" [hidden]="!hideCost">
      <div *ngIf="['part', 'tire', 'other','sublet', 'tireStorage', 'bundle'].includes(serviceItem?.type)"
        [hidden]="isFlatRateSubItem">
        <div *ngIf="!serviceItem?.orderItemId || !isPartsOrdingCostEditabled">
          <app-input placeholder="$0.00" styleClassInput="pl-0" styleClass="pl-0"
            id="estimate-service-item-cost-{{ cardIndex }}-{{ index }}" [fontSize]="12" [selectTextOnFocus]="true"
            [theme]="focus?.cost ? 'primary' : 'light'" [allowDecimal]="true" [autoFocus]="focus.cost" [disabled]="
          serviceItem?.lineItemType === 'refund' ||
          serviceItem?.type === 'bundle' ||
          serviceItem?.lineCartId ||
          isArchived ||
          !serviceItem?.type ||
          (serviceItem?.type !== 'other' && serviceItem?.type !== 'sublet' && !serviceItem?.itemId) ||
          (!serviceItem?.title && !serviceItem?.titleFR)
        " [value]="isTireStorage2Enabled && serviceItem?.tireStorageStatus !== 'return' && serviceItem?.type === 'tireStorage' && serviceItem?.pricingType === 'flatFee' ? (focus.cost ? serviceItem.mockFlatCost : serviceItem.mockFlatCost | currency : usd) : focus.cost ? defaultService.cost : (serviceItem.cost | currency : usd)"
            (appChange)="handleChange('cost', $event)" (appFocus)="handleFocus('cost')" (appBlur)="handleBlur('cost')">
          </app-input>
        </div>

        <app-content-overlay *ngIf="serviceItem?.orderItemId && isPartsOrdingCostEditabled" arrowRight="78%"
          arrowTop="-5px" top="31px" [closeOnTab]="false" [showArrow]="true" [showOnTab]="true"
          [disabled]="serviceItem?.lineItemType === 'refund' || isArchived">
          <ng-template appTemplate="item">
            <div id="estimate-service-item-discount-text-{{ cardIndex }}-{{ index }}"
              class="font-12 height-31 flex-start-center" [ngClass]="{ 'font-gray-65': isLast }">
              {{ serviceItem.cost | currency : usd }}

              <span *ngIf="Number(serviceItem.cost) !== Number(serviceItem.actualCost)">
                <i class="ml-1 fal fa-info-circle text-dark" [escape]="false" tooltipPosition="top"
                  pTooltip="Cost from {{ serviceItem?.itemSource }}: ${{ Number(serviceItem.actualCost).toFixed(2) }}<br>Updated cost: ${{ Number(serviceItem.cost).toFixed(2) }}"></i>
              </span>
            </div>
          </ng-template>

          <ng-template appTemplate="overlay" let-close="close" let-isOverlayVisible="isOverlayVisible"
            let-showOverlay="showOverlay">
            <div class="overlay-discount p-0 flex-column flex-center-start">
              <div class="flex-column font-13 pt-1 pl-1 pr-1">
                <span class="font-gray-35 font-12">{{ serviceItem?.itemSource }} cost</span>
                <span class="font-gray-35 font-14 font-600">{{ serviceItem.actualCost || 0 | currency : usd }}</span>
              </div>

              <div *ngIf="Number(serviceItem.cost) !== Number(serviceItem.actualCost)"
                class="flex-column font-13 pt-1 pl-1 pr-1">
                <span class="font-gray-35 font-12">Current cost</span>
                <span class="font-gray-35 font-14 font-600">{{ serviceItem.cost || 0 | currency : usd }}</span>
              </div>

              <div class="flex-column font-13 p-1">
                <span class="font-gray-35 font-12">Update cost</span>
                <app-input id="estimate-service-item-update-cost-{{ cardIndex }}-{{ index }}"
                  [isInvalid]="errors?.updateCost" placeholder="$0.00" styleClassInput="pl-0" styleClass="pl-0"
                  styleClassInput="font-600" [fontSize]="14" [allowDecimal]="true" [selectTextOnFocus]="true"
                  [theme]="focus?.updateCost ? 'primary' : 'light'" [autoFocus]="focus?.updateCost"
                  [value]="focus.updateCost ? serviceItem.updateCost : (serviceItem.updateCost | currency : usd)"
                  (appChange)="handleChange('updateCost', $event)" (appFocus)="handleFocus('updateCost')"
                  (appBlur)="handleBlur('updateCost')">
                </app-input>
              </div>

              <div class="width-100p mt-1 flex-end-center p-1 b-top">
                <button class="btn btn-cancel br-3 pointer font-12 mr-2"
                  (click)="close(); serviceItem.updateCost = ''; errors.updateCost = ''">
                  Cancel
                </button>

                <button class="btn btn-save br-3 pointer font-12"
                  [disabled]="isNaN(serviceItem.updateCost) || serviceItem.updateCost === ''"
                  (click)="handleUpdateCost(close)">
                  Save
                </button>
              </div>
            </div>
          </ng-template>
        </app-content-overlay>
      </div>
    </div>
    <!-- End Service Cost Section -->

    <!-- Start Service Price Section -->
    <div class="item price">
      <ng-container *ngIf="serviceItem?.lineItemType !== 'refund'; else adjustmentPriceInput">
        <div [hidden]="isFlatRateSubItem">
          <app-input placeholder="$0.00" styleClassInput="pl-0" styleClass="pl-0"
            id="estimate-service-item-price-{{ cardIndex }}-{{ index }}"
            theme="{{ focus?.price ? 'primary' : 'light' }}" [hidden]="serviceItem?.type === 'discount'"
            [selectTextOnFocus]="true" [allowDecimal]="true" [fontSize]="12" [autoFocus]="focus.price"
            [value]="isTireStorage2Enabled && serviceItem?.tireStorageStatus !== 'return' && serviceItem?.type === 'tireStorage' && serviceItem?.pricingType === 'flatFee' ? (focus.price ? serviceItem.mockFlatPrice : serviceItem.mockFlatPrice | currency : usd) : focus.price ? defaultService.price : (serviceItem.price | currency : usd)"
            [disabled]="serviceItem?.type === 'bundle' || !serviceItem?.type || isArchived || (serviceItem?.type !== 'other' && serviceItem?.type !== 'sublet' && !serviceItem?.itemId) || (!serviceItem?.title && !serviceItem?.titleFR)"
            (appChange)="handleChange('price', $event)" (appFocus)="handleFocus('price')"
            (appBlur)="handleBlur('price')">
          </app-input>
        </div>
      </ng-container>

      <ng-template #adjustmentPriceInput>
        <div [hidden]="isFlatRateSubItem" class="position-relative">
          <app-input placeholder="$0.00" styleClassInput="pl-0" styleClass="pl-0"
            id="estimate-service-item-price-{{ cardIndex }}-{{ index }}" theme="border"
            [hidden]="serviceItem?.type === 'discount'" [selectTextOnFocus]="true" [allowDecimal]="true" [fontSize]="12"
            [autoFocus]="focus.price"
            [value]="focus.price ? defaultService.price : (serviceItem.price | currency : usd)"
            [disabled]="serviceItem?.type === 'bundle' || !serviceItem?.type || isArchived || (serviceItem?.type !== 'other' && serviceItem?.type !== 'sublet' && !serviceItem?.itemId) || (!serviceItem?.title && !serviceItem?.titleFR)"
            (appChange)="handleChange('price', $event)" (appFocus)="handleFocus('price')"
            (appBlur)="handleBlur('price')">
          </app-input>

          <ng-container *ngIf="serviceItem?.type !== 'discount'">
            <i *ngIf="serviceItem?.originalPrice == serviceItem.price" class="fas fa-exclamation-circle price-warning"
              pTooltip="Returned price of the originally sold item"></i>
            <i *ngIf="serviceItem?.originalPrice > serviceItem.price"
              class="fas fa-exclamation-circle price-warning price-warning-orange"
              pTooltip="Returned price is less than original price"></i>
            <i *ngIf="serviceItem?.originalPrice < serviceItem.price"
              class="fas fa-exclamation-circle price-warning price-warning-red"
              pTooltip="Returned price can't be greater than original price"></i>
          </ng-container>
        </div>
      </ng-template>
    </div>
    <!-- End Service Price Section -->

    <!-- Start Service Quantity -->
    <div class="item quantity">
      <div>
        <ng-container
          *ngIf="isItemOrderQtyChangeFromALEnabled && ['part', 'tire'].includes(type) && serviceItem?.orderItemId; else defaultQtyChangeTemp">
          <app-content-overlay *ngIf="serviceItem?.orderItemId && ['part', 'tire'].includes(type)" arrowRight="73%"
            arrowTop="-13px" [disabled]="isArchived" [closeOnTab]="false" [showArrow]="true" [showOnTab]="true"
            (appShow)="openPartsOrderQtyOverlay()">
            <ng-template appTemplate="item">
              <div class="flex-start-center">
                <div id="estimate-service-item-qty-text-{{ cardIndex }}-{{ index }}"
                  class="online-item-update-qty font-12"
                  [ngClass]="{'dot-icon-neighbot': ['tire'].includes(type) && serviceItem.count > 0}"
                  pTooltip="Click to edit Quantity" tooltipPosition="top" [ngClass]="{ 'font-gray-65': isLast }">
                  {{ serviceItem.count || 0 | number : '1.2-2' }}
                </div>

                <div *ngIf="['tire'].includes(type) && serviceItem.count !== 0" class="dot-icon-wrapper"
                  tooltipPosition="right" [escape]="false"
                  (click)="!isArchived ? openTireDotNumberModal($event, true) : ''"
                  [pTooltip]="['deferred', 'deferredLocked', 'declined'].includes(serviceStatus) ? dotNumberTooltiponDisabled : dotIconTooltip"
                  tooltipStyleClass="tire-dot-tooltip" [ngClass]="{ 'not-allowed': isArchived || isFinalizedRo }">
                  <img style="height: 17px" src="assets/img/icon/{{dotIcon}}" alt="dot number" />
                  <img class="circle-exclamation-icon" src="assets/img/icon/circle-exclaimation-red.svg" alt="dot info"
                    *ngIf="isDotNumberReqOnInv && ['dot-number-yellow.svg','dot-number-red.svg'].includes(dotIcon)" />
                </div>
              </div>
            </ng-template>

            <ng-template appTemplate="overlay" let-close="close" let-isOverlayVisible="isOverlayVisible"
              let-showOverlay="showOverlay">
              <div class="overlay-quantity p-1 flex-column flex-center-start">
                <div class="qty-header border-bottom-lightest flex-row w-100 flex-between-center">
                  <span class="font-14 font-700">Edit quantity</span>
                  <i class="fal fa-times font-14 font-400 pointer" (click)="close()"></i>
                </div>
                <div class="qty-body flex-column w-100">
                  <div *ngIf="['TireHub', 'TireConnect'].includes(serviceItem?.itemSource)"
                    class="available-qty flex-between-center border-lightest">
                    <span class="font-12 font-400">Available qty. ({{ serviceItem.itemSource }})</span>
                    <span class="font-14 font-600">
                      {{ availableQty | number : '1.2-2' }}
                      <i *ngIf="!isCheckingAvailability" class="fa-flip-horizontal fa-undo far"
                        (click)="$event.stopPropagation(); openPartsOrderQtyOverlay()"></i>
                      <i *ngIf="isCheckingAvailability" class="fal fa-spinner rotate"></i>
                    </span>
                  </div>

                  <div class="overlay-input-qty w-100">
                    <div class="font-12 font-400">Quantity</div>
                    <app-input id="estimate-service-item-update-qty-{{ cardIndex }}-{{ index }}"
                      [isInvalid]="errors?.updateCount" placeholder="$0.00" styleClassInput="pl-0" styleClass="pl-0"
                      styleClassInput="font-600" theme="primary" [selectTextOnFocus]="true"
                      [autoFocus]="focus?.updateCount" [fontSize]="14" [allowDecimal]="true"
                      [disabled]="serviceItem.itemSource === 'Nexpart' ? (!isValidNexPartEdit || isUpdatingQuantity || isCheckingAvailability) : (isUpdatingQuantity || isCheckingAvailability)"
                      [value]="focus.updateCount ? serviceItem.updateCount : (serviceItem.updateCount | number : '1.2-2')"
                      (appChange)="handleChange('updateCount', $event)" (appFocus)="handleFocus('updateCount')"
                      (appBlur)="handleBlur('updateCount')">
                    </app-input>
                  </div>

                  <div *ngIf="serviceItem.itemSource !== 'Nexpart' && qtyUpdateError" class="overlay-input-qty w-100">
                    {{ qtyUpdateError }}
                  </div>

                  <div *ngIf="serviceItem.itemSource === 'Nexpart'" class="overlay-input-qty w-100 font-12 font-red">
                    {{ checkOnlineOrderingNexPartValidation() }}
                  </div>

                  <div class="flex-row gap-2"  *ngIf="isPartOrdered()">
                    <div class="qty-goto font-12 ui-g-6 font-700 flex-center-center"
                      (click)="handleDeliverOrder()">
                      Mark as Delivered
                    </div>

                    <div class="qty-goto ui-g-6 font-12 font-700 flex-center-center"
                    (click)="openPartsOrderingPage(serviceItem.itemSource, serviceItem.count)">
                    Go to {{ serviceItem.itemSource }}
                    <i class="far fa-arrow-right pl-2"></i>
                    </div>

                   
                  </div>
                  
                  <div class="qty-goto font-12 font-700 flex-center-center"  *ngIf="!isPartOrdered()"
                    (click)="openPartsOrderingPage(serviceItem.itemSource, serviceItem.count)">
                    Go to {{ serviceItem.itemSource }}
                    <i class="far fa-arrow-right pl-2"></i>
                  </div>
                </div>

                <div class="qty-footer border-top-lightest flex-end-center w-100">
                  <button class="btn btn-cancel br-3 pointer font-12 mr-2" (click)="close()">
                    Cancel
                  </button>
                  <button [disabled]="serviceItem.itemSource === 'Nexpart' ? !isValidNexPartEdit || !serviceItem.updateCount || isUpdatingQuantity || isCheckingAvailability : !serviceItem.updateCount || isUpdatingQuantity || isCheckingAvailability"
                    class="btn br-3 font-12" [ngClass]="serviceItem.itemSource === 'Nexpart' && !isValidNexPartEdit ? 'btn-disabled not-allowed': 'btn-save pointer'" (click)="updatePartsOrderItemCount(close)">
                    Update
                    <i *ngIf="isUpdatingQuantity" class="fal fa-spinner rotate ml-2"></i>
                  </button>
                </div>
              </div>
            </ng-template>
          </app-content-overlay>
        </ng-container>

        <ng-template #defaultQtyChangeTemp>
          <ng-container *ngIf="serviceItem?.lineItemType !== 'refund'; else adjustmentCountInput">
            <div class="d-flex position-relative"
              [ngClass]="{'dot-icon-neighbor': ['tire'].includes(type) && serviceItem.count > 0}"
              style="align-items: baseline">
              <app-input *ngIf="['tire', 'tireStorage', 'bundle'].includes(type)" styleClassInput="pl-0"
                styleClass="pl-0" placeholder="0" id="estimate-service-item-qty-{{ cardIndex }}-{{ index }}"
                tooltipPosition="top" [escape]="false"
                pTooltip="{{ isTireStorage2Enabled && serviceItem?.tireStorageStatus !== 'return' && serviceItem?.type === 'tireStorage' && serviceItem?.pricingType === 'flatFee' ? 'To adjust the number of tires in this set, update the &quot;How many tires are we storing&quot;? field in the tire storage details modal.' : serviceItem?.type === 'tireStorage' && !isTireStorage2Enabled ? 'Delete items from the item modal to edit quantity' : '' }}"
                [selectTextOnFocus]="true" [allowDecimal]="focus?.count ? true : false" [autoFocus]="focus.count"
                [theme]="focus?.count ? 'primary' : 'light'" [fontSize]="12"
                [value]="isTireStorage2Enabled && serviceItem?.tireStorageStatus !== 'return' && serviceItem?.type === 'tireStorage' && serviceItem.pricingType === 'flatFee' ?  (1 | number : '1.2-2') : focus.count ? defaultService.count : (serviceItem.count | number : '1.2-2')"
                [disabled]="
                (isTireStorage2Enabled && serviceItem?.tireStorageStatus !== 'return' && serviceItem?.type === 'tireStorage' && serviceItem?.pricingType === 'flatFee') ||
                (isTireStorage2Enabled && serviceItem?.tireStorageStatus !== 'return' && serviceItem?.type === 'tireStorage' && invoicedRO) ||
              serviceItem?.orderItemId ||
              serviceItem?.type === 'bundle' ||
              !serviceItem?.type ||
              isFinalizedRo ||
              (serviceItem?.type !== 'other' && serviceItem?.type !== 'sublet' && !serviceItem?.itemId) ||
              ['discount'].includes(serviceItem?.type) || (['tireStorage'].includes(serviceItem?.type) && !isTireStorage2Enabled) ||
              (['tireStorage'].includes(serviceItem?.type) && isTireStorage2Enabled && serviceItem.tireStorageStatus === 'return' ) || (!serviceItem?.title && !serviceItem?.titleFR  )"
                (appFocus)="handleFocus('count')" (appBlur)="handleBlur('count')"
                (appChange)="handleChange('count', $event)">
              </app-input>

              <app-input *ngIf="['', 'part', 'labor', 'other','sublet', 'hazmatFee'].includes(type)"
                styleClassInput="pl-0" tooltipPosition="top" styleClass="pl-0" placeholder="0"
                id="estimate-service-item-count-{{ cardIndex }}-{{ index }}"
                [allowDecimal]="focus?.count ? true : false" [pTooltip]="serviceItem?.unitOfMeasuring"
                [selectTextOnFocus]="true"
                [disabled]="serviceItem?.orderItemId || isArchived || !serviceItem?.type || (serviceItem?.type !== 'other' && serviceItem?.type !== 'sublet' && !serviceItem?.itemId) || (!serviceItem?.title && !serviceItem?.titleFR)"
                [theme]="focus?.count ? 'primary' : 'light'"
                [value]="focus.count ? defaultService.count : (serviceItem.count | number : '1.2-2')" [fontSize]="12"
                [autoFocus]="focus.count" (appFocus)="handleFocus('count')" (appBlur)="handleBlur('count')"
                (appChange)="handleChange('count', $event)">
              </app-input>

              <div *ngIf="['tire'].includes(type) && serviceItem.count !== 0" class="dot-icon-wrapper"
                [disabled]="['deferred', 'deferredLocked', 'declined'].includes(serviceStatus)" tooltipPosition="right"
                [escape]="false" (click)="!isArchived ? openTireDotNumberModal($event) : ''"
                [pTooltip]="['deferred', 'deferredLocked', 'declined'].includes(serviceStatus) ? dotNumberTooltiponDisabled : dotIconTooltip"
                tooltipStyleClass="tire-dot-tooltip"
                [ngClass]="{ 'not-allowed': isArchived || ['deferred', 'deferredLocked', 'declined'].includes(serviceStatus) || isFinalizedRo }">
                <img style="height: 17px" src="assets/img/icon/{{dotIcon}}" alt="dot number" />
                <img class="circle-exclamation-icon" src="assets/img/icon/circle-exclaimation-red.svg" alt="dot info"
                  *ngIf="isDotNumberReqOnInv && ['dot-number-yellow.svg','dot-number-red.svg'].includes(dotIcon)" />
              </div>

              <div
                *ngIf="['tireStorage'].includes(type) && isTireStorage2Enabled && serviceItem.count !== 0 && (!serviceItem?.tireStorageStatus || ['remove', 'store'].includes(serviceItem?.tireStorageStatus))"
                class="tire-storage-icon-wrapper"
                [disabled]="['deferred', 'deferredLocked', 'declined'].includes(serviceStatus)" tooltipPosition="top"
                [escape]="false" (click)="!isArchived ? handleOpenItemModal(serviceItem?.itemId, false, false) : ''"
                [pTooltip]="tireStorageIconTooltip" tooltipStyleClass="tire-dot-tooltip"
                [ngClass]="{ 'not-allowed': isArchived || ['deferred', 'deferredLocked', 'declined'].includes(serviceStatus) }">
                <img style="height: 17px" src="assets/img/icon/{{tireStorageInfoIcon}}" alt="dot number"
                  *ngIf="['tire-storage-green-icon.svg','tire-storage-red-icon.svg'].includes(tireStorageInfoIcon)" />
              </div>
            </div>
          </ng-container>

          <ng-template #adjustmentCountInput>
            <div class="d-flex position-relative"
              [ngClass]="{'dot-icon-neighbor': ['tire'].includes(type) && serviceItem.count > 0}"
              style="align-items: baseline">
              <app-input *ngIf="['tireStorage','tire','bundle'].includes(type)" styleClassInput="pl-0" styleClass="pl-0"
                placeholder="0" id="estimate-service-item-qty-{{ cardIndex }}-{{ index }}" tooltipPosition="top"
                theme="border" [fontSize]="12" [selectTextOnFocus]="true" [autoFocus]="focus.count"
                [mask]="focus?.count ? '-0*' : ''" value="{{ focus.count ? defaultService.count : serviceItem.count }}"
                pTooltip="{{ serviceItem?.type === 'tireStorage' && !isTireStorage2Enabled ? 'Delete items from the item modal to edit quantity' : '' }}"
                [allowNegative]="true" [disabled]="
              serviceItem?.orderItemId ||
              serviceItem?.type === 'bundle' ||
              !serviceItem?.type ||
              isFinalizedRo ||
              (serviceItem?.type !== 'other' && serviceItem?.type !== 'sublet' && !serviceItem?.itemId) ||
              ['discount'].includes(serviceItem?.type) || (['tireStorage'].includes(serviceItem?.type) && !isTireStorage2Enabled) ||
              (!serviceItem?.title && !serviceItem?.titleFR)
            " (appFocus)="handleFocus('count')" (appBlur)="handleBlur('count')"
                (appChange)="handleChange('count', $event)">
              </app-input>

              <app-input *ngIf="['', 'part' ,'labor', 'other', 'sublet', 'hazmatFee'].includes(type)"
                styleClassInput="pl-0" tooltipPosition="top" styleClass="pl-0" placeholder="0" theme="border"
                [autoFocus]="focus.count" id="estimate-service-item-count-{{ cardIndex }}-{{ index }}"
                [allowNegative]="true" [allowDecimal]="focus?.count ? true : false"
                [pTooltip]="serviceItem?.unitOfMeasuring" [selectTextOnFocus]="true" [fontSize]="12"
                [value]="focus.count ? defaultService.count : (serviceItem.count | number : '1.2-2')"
                [disabled]="serviceItem?.orderItemId || isArchived || !serviceItem?.type || (serviceItem?.type !== 'other' && serviceItem?.type !== 'sublet' && !serviceItem?.itemId) || (!serviceItem?.title && !serviceItem?.titleFR)"
                (appFocus)="handleFocus('count')" (appBlur)="handleBlur('count')"
                (appChange)="handleChange('count', $event)">
              </app-input>

              <ng-container *ngIf="serviceItem?.type !== 'discount'">
                <i *ngIf="serviceItem?.originalCount == (serviceItem.count * -1) && ['tireStorage' ,'bundle'].includes(type)"
                  class="fas fa-exclamation-circle price-warning one"
                  pTooltip="Returned qty/hrs of the originally sold item"></i>
                <i *ngIf="serviceItem?.originalCount > (serviceItem.count * -1)"
                  class="fas fa-exclamation-circle price-warning price-warning-orange two"
                  pTooltip="Returned qty/hrs is less than original qty/hrs"></i>
                <i *ngIf="serviceItem?.originalCount < (serviceItem.count * -1)"
                  class="fas fa-exclamation-circle price-warning price-warning-red three"
                  pTooltip="Returned qty/hrs can't be greater than original qty/hrs"></i>
              </ng-container>

              <div *ngIf="['tire'].includes(type) && serviceItem.count !== 0" class="dot-icon-wrapper"
                tooltipPosition="right" [escape]="false" (click)="!isArchived ? openTireDotNumberModal($event) : ''"
                [pTooltip]="['deferred', 'deferredLocked', 'declined'].includes(serviceStatus) ? dotNumberTooltiponDisabled : dotIconTooltip"
                tooltipStyleClass="tire-dot-tooltip" [ngClass]="{ 'not-allowed': isArchived || isFinalizedRo }">
                <img style="height: 17px" src="assets/img/icon/{{dotIcon}}" alt="dot number" />
                <img class="circle-exclamation-icon" src="assets/img/icon/circle-exclaimation-red.svg" alt="dot info"
                  *ngIf="isDotNumberReqOnInv && ['dot-number-yellow.svg','dot-number-red.svg'].includes(dotIcon)" />
              </div>

              <div
                *ngIf="['tireStorage'].includes(type) && isTireStorage2Enabled && serviceItem.count !== 0 && (!serviceItem?.tireStorageStatus || ['remove', 'store'].includes(serviceItem?.tireStorageStatus))"
                class="tire-storage-icon-wrapper"
                [disabled]="['deferred', 'deferredLocked', 'declined'].includes(serviceStatus)" tooltipPosition="top"
                [escape]="false" (click)="!isArchived ? handleOpenItemModal(serviceItem?.itemId, false, false) : ''"
                [pTooltip]="tireStorageIconTooltip" tooltipStyleClass="tire-dot-tooltip"
                [ngClass]="{ 'not-allowed': isArchived || ['deferred', 'deferredLocked', 'declined'].includes(serviceStatus) }">
                <img style="height: 17px" src="assets/img/icon/{{tireStorageInfoIcon}}" alt="dot number"
                  *ngIf="['tire-storage-green-icon.svg','tire-storage-red-icon.svg'].includes(tireStorageInfoIcon)" />
              </div>
            </div>
          </ng-template>
        </ng-template>
      </div>
    </div>
    <!-- End Service Quantity -->

    <!-- Start Service Total -->
    <div class="item flex-start-center subtotal" id="estimate-service-item-subtotal-{{ cardIndex }}-{{ index }}">
      <div class="item-label font-12" [ngClass]="{ 'font-gray-65': isLast }"
        [hidden]="serviceItem?.type === 'discount'">
        {{ serviceItem.subTotal | currency : usd }}
      </div>
    </div>
    <!-- End Service Total -->

    <!-- Start discount -->
     <!-- adding the condition not to editable on finalized RO against ticket ALP-19935-->
    <div class="item flex-start-center discount"
      [ngClass]="{ 'not-allowed important': ['discount', 'hazmatFee'].includes(serviceItem?.type) || !serviceItem?.type || isArchived || (serviceItem?.type !== 'other' && serviceItem?.type !== 'sublet' && !serviceItem?.itemId) }">
      <app-content-overlay *ngIf="!['discount', 'bundle'].includes(serviceItem?.type)" arrowRight="28%" arrowTop="-5px"
        [closeOnTab]="false" [showArrow]="true" [showOnTab]="true"
        [disabled]="isFinalizedRo || ['discount', 'hazmatFee'].includes(serviceItem?.type) || !serviceItem?.type || isArchived || (serviceItem?.type !== 'other' && serviceItem?.type !== 'sublet' && !serviceItem?.itemId) || (!serviceItem?.title && !serviceItem?.titleFR)">
        <ng-template appTemplate="item">
          <div id="estimate-service-item-discount-text-{{ cardIndex }}-{{ index }}" class="font-12"
            style="margin-left: -24px" [ngClass]="{ 'font-gray-65': isLast }">
            {{ discount?.value || 0 | currency : usd }} ({{ discount.percentage ||
            0 | number : '1.2-2' }}%)
          </div>
        </ng-template>

        <ng-template appTemplate="overlay" let-close="close" let-isOverlayVisible="isOverlayVisible"
          let-showOverlay="showOverlay">
          <div class="overlay-discount p-1 flex-column flex-center-start">
            <div class="input-box flex-start-end">
              <div class="overlay-dropdown mr-2">
                <app-dropdown theme="primary" itemWidth="120px"
                  id="d-estimate-service-item-discount-{{cardIndex}}-{{index}}"
                  listId="d-estimate-service-item-discount-list-{{cardIndex}}-{{index}}" [fontSize]="12"
                  [value]="discountType" (appSelect)="onDiscountChange('type', $event, serviceItem)"
                  [isDropdownIconVisible]="true" [options]="config.estimate.discountType"
                  [disabled]="isArchived || serviceItem?.lineItemType === 'refund'"
                  (appShiftTab)="focus.isTaxable = true">
                </app-dropdown>
              </div>

              <div class="overlay-input">
                <app-input [selectTextOnFocus]="true" id="estimate-service-item-discount-{{cardIndex}}-{{index}}"
                  placeholder="0" [mask]="discountType?.type === 'percentage' ? 'percent' : ''"
                  [allowDecimal]="discountType?.type !== 'percentage'" [autoFocus]="isOverlayVisible" [fontSize]="12"
                  [disabled]="isArchived || serviceItem?.lineItemType === 'refund'"
                  [value]="serviceItem?.discount?.value || ''"
                  (appChange)="onDiscountChange('value', $event, serviceItem)" (appBlur)="handleBlur('discountValue')"
                  (appEnter)="saveDiscount(close)" (appTabPress)="close()">
                </app-input>
              </div>
            </div>

            <div class="width-100p mt-1 flex-end-center">
              <span class="btn btn-cancel br-3 pointer font-12 mr-2" (click)="close()">Cancel</span>
              <span class="btn btn-save br-3 pointer font-12" [disabled]="serviceItem?.lineItemType === 'refund'"
                (click)="saveDiscount(close)">Save</span>
            </div>
          </div>
        </ng-template>
      </app-content-overlay>

      <div *ngIf="serviceItem?.type === 'discount'" class="item-label font-12"
        [ngClass]="{ 'font-gray-65': isLast, 'not-allowed': isArchived }"
        (click)="handleOpenItemModal(serviceItem?.itemId, false)">
        {{ serviceItem?.price | currency : usd }} ({{
        serviceItem?.discountPercentage }}%)
      </div>
    </div>
    <!-- End discount -->

    <!-- Start Service Net Total -->
    <div *ngIf="isQuickbooksCalCompatibiltyOn" class="item flex-start-center net-subtotal"
      id="estimate-service-item-subtotal-{{cardIndex}}-{{index}}">
      <div class="item-label font-12" style="margin-left: 7px" [ngClass]="{ 'font-gray-65': isLast }">
        {{ serviceItem.netSubTotal | currency : usd }}
      </div>
    </div>
    <!-- End Service Net Total -->

    <!-- Start Taxable -->
    <div class="item flex-start-center ss-item-taxable taxable">
      <!-- {{serviceItem.propDiscount}} -->
       <!-- adding the condition not to editable on finalized RO against ticket ALP-19935-->
      <div *ngIf="serviceItem?.type !== 'bundle'" class="item-label width-100p font-12"
        [ngClass]="{ 'font-gray-65': isLast }">
        <app-dropdown field="label" itemWidth="110px" styleClassDropdownList="top-38" styleClassSelectedView="p-6p"
          styleClassError="top-35 left-7" placeholder="Taxable"
          id="d-estimate-service-item-taxable-{{cardIndex}}-{{index}}"
          listId="d-estimate-service-item-taxable-list-{{cardIndex}}-{{index}}" [hasBorderBottomOnActive]="true"
          [theme]="focus?.isTaxable ? 'primary' : 'light'" [autoFocus]="focus.isTaxable"
          [disabled]="isFinalizedRo || serviceItem?.lineItemType === 'refund' || !serviceItem?.type || isArchived || serviceItem?.isPassThroughTax || (serviceItem?.type !== 'other' && serviceItem?.type !== 'sublet' && !serviceItem?.itemId) || serviceItem?.type === 'bundle' || (!serviceItem?.title && !serviceItem?.titleFR)"
          [options]="[
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ]" [fontSize]="12" [value]="{ label: !!serviceItem.isTaxable ? 'Yes' : 'No' }" [isDropdownIconVisible]="true"
          [showSelectedValue]="true" [isInline]="true" (appSelect)="handleDropdownSelect('isTaxable', $event)"
          (appOpenDropdown)="handleFocus('isTaxable')" (appClickOutside)="handleBlur('isTaxable')">
        </app-dropdown>
      </div>
    </div>
    <!-- End Taxable -->

    <!-- Start tag list -->
    <div class="item flex-start-center status pl-0">
      <app-tags-list addTagTitle="Add tags" itemWidth="190px" inputBoxWidth="100%" hPosition="left" scrollHeight="70px"
        buttonId="estimate-service-item-tags-{{cardIndex}}-{{index}}" [tags]="serviceTags" [type]="tagTypeService"
        [isSetPositionDynamically]="false" [stopPropagation]="false" [maxLimit]="3" [isDeleteable]="true"
        [selectedTags]="serviceItem?.tags" [extraTags]="partOrderingTags" [extraTagTruncate]="true" [fontSize]="9"
        [hasCreateOption]="!isFlatRateSubItem" [isDeleteable]="true"
        [disabled]="!serviceItem?.type || isArchived || (!['other', 'sublet'].includes(serviceItem?.type) && !serviceItem?.itemId) || (!serviceItem?.title && !serviceItem?.titleFR)"
        (appClick)="onTagClick($event)" (appSelect)="onTagSelect($event)" (appDelete)="onTagDelete($event)"
        (appUpdateTag)="_updateTags($event)" (appCreateTag)="onTagCreate($event)" (appTagDeleted)="handleTagDelete($event)">
      </app-tags-list>
    </div>
    <!-- End tag list -->
  </ng-container>
  <!-- with without partsLookup end -->


  <ng-container *ngIf="type === 'partLookUp' && !serviceItem?.isAddedFromPartLookup && serviceItem?.title">
    <div class="lookup-btn-width lookup-list-item-wrapper">

      <!-- Select parts button -->
      <div *ngIf="!serviceItem?.partLookupInventoryList?.length && serviceItem.title === ''">
        <button [disabled]="isArchived" class="w-100 btn btn-primary-light font-bold"
          (click)="openDialog(serviceItem,cardIndex,index)">
          <span>
            <i class="font-bold fal fa-plus pl-2"></i>
          </span>
          Select Parts

          <span *ngIf="isDialogOpening"><i class="ml-2 fal fa-spinner rotate"></i></span>
        </button>
      </div>
      <!--  -->
      <div class="mpl-wrapper-row" *ngIf="!serviceItem?.listLoaded">
        <button id="search-inventory-service-item-action-{{ cardIndex }}-{{ index }}" [disabled]="isArchived"
          class="w-100 btn btn-white sync-catalog font-700" (click)="openDialog(serviceItem,cardIndex,index)">
          <span>
            <i class="font-bold fal fa-sync pr-1"></i>
          </span>
          Search Inventory & Catalog

          <span *ngIf="isDialogOpening"><i class="ml-2 fal fa-sync rotate"></i></span>
        </button>
      </div>

      <!-- MPL selection -->
      <div class="mpl-wrapper-row" *ngIf="serviceItem?.listLoaded">
        <div class="mpl-wrapper-col">
          <h6 class="mpl-color">
            <i class="far fa-check"></i>
            <strong>Lookup complete</strong>
          </h6>
        </div>
        <div class="mpl-wrapper-col mpl-pill-btn-wrapper" id="parent-of-force-down-inventory-lookup" #btnWrapper>
          <div #forceClick *ngIf="serviceItem?.partLookupInventoryList?.length"
            class="mpl-pill-btn mpl-bg-bor width-50 viewInventory inventory-part-btn" (click)="togglePopover($event, op)">
            <i class="far fa-boxes pr-1"></i>
            View Inventory & Catalog items
          </div>
          <div *ngIf="serviceItem?.partLookupInventoryList?.length" class="plain-text">OR</div>
          <!-- (click)="" -->
          <div class="mpl-pill-btn order-part-btn"
             tooltipPosition="top"
            tooltipStyleClass="tooltip-width-medium text-center"
            [pTooltip]="!isPartsTechConnected && !isNexpartConnected ? 'No online part ordering integrations configured. Please enable integrations in Settings.' : ''"
            [ngClass]="{
            'full-width': !serviceItem?.partLookupInventoryList?.length,
            'width-50': serviceItem?.partLookupInventoryList?.length,
            'div-disabled pointer-event': !isPartsTechConnected && !isNexpartConnected
          }"
          (click)="onlineOrder(cardIndex, index)"
          >
            <img *ngIf="preferredInventoryOnlineLookup === 'partsTech' && isPartsTechConnected" width="20"
              src="assets/img/partstech-logo-circle.svg" />
            <img *ngIf="preferredInventoryOnlineLookup === 'nexPart' && isNexpartConnected" width="58"
              src="assets/img/nextpart-integration.svg" />
            Order part(s)
          </div>
        </div>

        <!-- Outer Overlay Panel -->
        <p-overlayPanel id="search-inventory-service-item-overlayPanel-{{ cardIndex }}-{{ index }}" #op
          [styleClass]="'custom-overlay fixed-position-overlay'" [appendTo]="'body'">
          <div class="custom-card" [style.width]="btnWrapper?.offsetWidth + 'px'">
            <div class="card-body">

            <!-- First Row -->
              <div class="mpl-overlay-row" *ngFor="let item of serviceItem?.partLookupInventoryList; let i=index">
                <div class="mpl-overlay-col-left">
                  <div class="mpl-checkbox-wrapper">
                    <app-checkbox [isChecked]="defaultCheck"
                    inputId="inv-checkbox-{{ cardIndex }}-{{ index }}-{{ i }}"
                    (appChange)="onSelectPartLookup(item, $event, true, i)"></app-checkbox>
                  </div>
                <span [pTooltip]="item?.partName.length > 32 && item?.partName" tooltipPosition="top"
                  style="font-size: 13px; margin-left: 5px;font-weight: 600;">
                  {{ item?.partName.length > 32 ? (item?.partName | slice:0:32) + '...' : item?.partName }}
                </span>
                <span>:</span>
                <div class="mpl-sr-number-wrapper">
                  <span class="pl-hover-number partNumber ml-2" [pTooltip]="copiedIndex == i ? 'Copied!' : 'Copy'"
                    (click)="copyText(item?.partNumber, i)" [ngClass]="copiedIndex == i ? 'copied-active' : ''">
                    <span class="font-14 font-gray-700" style="font-size: 13px;">{{ item?.partNumber }}</span>
                    <i *ngIf="copiedIndex == i" class="pt-1 fas fa-copy copy-icon"></i>
                    <i *ngIf="copiedIndex !== i" class="pt-1 far fa-copy font-14 copy-icon"></i>
                  </span>
                </div>
              </div>
              <div class="mpl-overlay-col-right">
                <div
                  *ngIf="isMultiLocationEnabled && item?.itemInfo?.stockDetails?.length && item?.itemInfo?.countAvailable <= 0"
                  class="mpl-inventory-ddl-wrapper" (mouseenter)="showOverlay($event, op2)"
                  (mouseleave)="hideOverlayWithDelay(op2)">
                  <span #innerTrigger class="w-100">Non-local</span>
                </div>

                <!-- Inner Overlay Panel (Always Opens on Top) -->
                <p-overlayPanel #op2 [styleClass]="'customer-fixed-top hover-panel'" [appendTo]="'parent'"
                  (mouseenter)="cancelHideOverlay()" (mouseleave)="hideOverlayWithDelay(op2)">
                  <div class="custom-card">
                    <h4>Available non-local inventories</h4>
                    <div *ngFor="let otherItem of item?.itemInfo?.stockDetails" class="mpl-inneroverlay-list">
                      <p><b>({{otherItem?.countAvailable}})</b> - {{otherItem?.name}}</p>
                    </div>
                  </div>
                </p-overlayPanel>

                <div class="mpl-inventory-qty-wrapper">
                  Qty available: <strong class="pl-1">{{ numberFormat(item?.itemInfo?.countAvailable || 0)
                    }}</strong>
                </div>
                <div class="mpl-inventory-cost-wrapper">
                  Cost: <strong class="pl-1">{{ item?.itemInfo?.cost | currency: 'USD' }}</strong>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer Section -->
          <div class="card-footer">
            <button class="btn btn-border pointer btn-submit mr-2 font-600" [id]="cancel+cardIndex+index"
              (click)="closePopover(op)">
              Cancel
            </button>
            <button class="btn btn-primary btn-submit" [id]="add-repair+cardIndex+index"
              [disabled]="disableInventoryOrder || isProcessing" (click)="addRepairOrder(cardIndex,index)">
              <span class="font-600">Add to Repair Order</span>
            </button>
          </div>
        </div>
        </p-overlayPanel>
      </div>

    </div>
  </ng-container>
  <!-- show only on part type partLookup selection -->
  <ng-container *ngIf="type === 'partLookUp' && !serviceItem?.isAddedFromPartLookup && !serviceItem?.title">
    <div class="lookup-btn-width lookup-list-item-wrapper">
      <div class="mpl-wrapper-row-lookup-pills">
        <div class="mpl-wrapper-col">
          <h6>Quick selection:</h6>
        </div>
        <div class="mpl-wrapper-col pills-container">
          <div *ngFor="let item of visibleItems" class="mpl-pill" (click)="openDialog(item, cardIndex, index, true)">
            {{ item?.name }}
          </div>
        </div>

      </div>
    </div>
  </ng-container>
  <!--end show only on part type partLookup selection  -->

  <!-- Service action -->
  <div class="item flex-center-center delete">
    <!-- {{serviceItem?.tags?.name}} -->
    <i *ngIf="!isStocksLoading" class="stocked-icon fas fa-boxes mr-2" tooltipPosition="top" [pTooltip]="stockTooltip"
      [ngClass]="{ invisible: !serviceItem?.stocked }" (click)="fetchStockDetails($event)"></i>

    <i *ngIf="isStocksLoading" class="stocked-icon fa fa-spinner rotate mr-2" tooltipPosition="top"
      [pTooltip]="stockTooltip" [ngClass]="{ invisible: !serviceItem?.stocked }"
      (click)="fetchStockDetails($event)"></i>

    <app-dropdown id="estimate-service-item-action-{{ cardIndex }}-{{ index }}"
      listId="estimate-service-item-action-list-{{ cardIndex }}-{{ index }}" hPosition="left" scrollHeight="215px"
      itemWidth="180px" styleClassSelectedView="p-0" [disabled]="serviceItem?.type !== 'tireStorage' && (isArchived || !serviceItem?.itemId)"
      [focusOnSelectedValue]="false" [options]="serviceActionOptions" [hasCustomOpenTemplate]="true"
      [hasCustomItemTemplate]="true" [ngClass]="{ invisible: isFlatRateSubItem }" [isDropdownIconVisible]="false"
      [closeOnSelection]="true" (appSelect)="handleServiceItemAction($event)" (appCloseDropdown)="handleBlur('delete')">
      <ng-template let-item appTemplate="open-dropdown-btn">
        <i class="far fa-ellipsis-v pointer pr-2 pl-2"
          [ngClass]="{ 'not-allowed': serviceItem?.type !== 'tireStorage' && (isArchived || !serviceItem?.itemId) , pointer: !isArchived }"></i>
      </ng-template>

      <ng-template let-item appTemplate="item">
        <div class="flex-start-center font-12">
          {{ item?.name }}
        </div>
      </ng-template>
    </app-dropdown>
  </div>
</div>

<span *ngFor="let subItem of serviceItem?.subItems; let subItemIndex = index" [hidden]="serviceItem?.isExpanded">
  <app-service-item [isFlatRateSubItem]="true" [isPartsTechConnected]="isPartsTechConnected"
    [isNexpartConnected]="isNexpartConnected" [motorVehicle]="motorVehicle" [isBalanceNegative]="isBalanceNegative"
    [serviceTitle]="title" [isDiscountItemEnabled]="isDiscountItemEnabled"
    [isPartsOrdingCostEditabled]="isPartsOrdingCostEditabled"
    [uniqueInternalReferenceCount]="uniqueInternalReferenceCount" [countOfItemsExistsInFees]="countOfItemsExistsInFees"
    [estimateId]="estimateId" [customerId]="customerId" [vehicleId]="vehicleId" [itemTypeOptions]="itemTypeOptions"
    [defaultItemTypeOptions]="defaultItemTypeOptions" [customFleetSettings]="customFleetSettings" [adHocMap]="adHocMap"
    [isReturnFeatureEnabled]="isReturnFeatureEnabled" [hasCore]="false" [hasReturn]="false"
    [isPartsOrderingDisassociateEnabled]="isPartsOrderingDisassociateEnabled"
    [isQuickbooksCalCompatibiltyOn]="isQuickbooksCalCompatibiltyOn" [isOtherTaxable]="isOtherTaxable"
    [vehicleName]="vehicleName" [motorLaborPricing]="motorLaborPricing" [currentLang]="currentLang"
    [isFinalizedRo]="isFinalizedRo" [companyLocalization]="companyLocalization"
    [isArchived]="!['tire', 'partLookUp'].includes(subItem.type)" [bundleItem]="serviceItem"
    [itemSettings]="itemSettings" [motorVehicle]="motorVehicle" [estimateCode]="estimateCode" [serviceId]="serviceId"
    [serviceItem]="subItem" [defaultTax]="defaultTax" [qboRefs]="qboRefs" [remainingAmount]="remainingAmount"
    [index]="subItemIndex" [bundleLineItemIndex]="index" [cardIndex]="cardIndex" [serviceTags]="serviceTags">
  </app-service-item>
</span>
